import { ApplicationConfig, enableProdMode, inject, mergeApplicationConfig, provideAppInitializer } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideDatadogErrorHandler, provideDatadogRouter } from '@datadog/browser-rum-angular';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { DatadogRumService } from './app/shared/services/datadog-rum.service';
import { environment } from './environments/environment';

// Kept out of the shared appConfig (app.config.ts) because
// app.config.server.ts merges that same config into the SSR bootstrap,
// and these are browser-only: registering provideDatadogRouter()/
// provideDatadogErrorHandler() server-side would install Datadog's
// ErrorHandler and router hooks in the Node.js renderer for a client-only
// SDK that never actually initializes there (Copilot review, USONESHOP-3946).
const browserConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => inject(DatadogRumService).init()),
    provideDatadogRouter(),
    provideDatadogErrorHandler(),
  ],
};

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, mergeApplicationConfig(appConfig, browserConfig))
  .catch((err) => console.error(err));